module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid24_1020x866.2c3c7c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid24_1020x866.jpg
// module id = Gs0N
// module chunks = 0